import React from 'react';

import { $changeZIndex } from './../../mixin/mixin-jquery';

class SingleDegree extends React.Component {
  constructor() {
    super();

    this._handleTitleClick = this._handleTitleClick.bind(this);
    this._handleButtonClick = this._handleButtonClick.bind(this);

    this._$changeZIndex = $changeZIndex;

    this.state = {
      active: false
    };
  }

  _handleTitleClick() {
    this.setState({active: !this.state.active});
  }

  _handleButtonClick(id, e) {
    e.preventDefault();
    let actions = [
      {type: 'LBOX::OPEN'},
      {type: 'CURR_DEGREE::UPDATE', value: id},
      {type: 'UNITS::FETCH', value: id}
    ];

    // open lightbox
    this.props.dispatchReducer(actions);
    // increase container's z-index to override everything
    this._$changeZIndex($('#main-wrapper'), 10000);
    $('html').addClass('no-scroll');
  }

  render() {
    var { data } = this.props;

    return <div className={this.state.active ? 'react-accordion active' : 'react-accordion'}>
          <div className="title-wrap">
            <h2 className="title" onClick={this._handleButtonClick.bind(null,data.assetid)}>{data.name}</h2>
            <span className="icon__expand" onClick={this._handleTitleClick}></span>
          </div>
          <div className="panel">
            <p dangerouslySetInnerHTML={{ __html: data.description}} />
            <p className="clearfix">

              <a href="see.units"
                 className="button type-2 btn-see-units"
                 onClick={this._handleButtonClick.bind(null,data.assetid)}>
                 See Units
               </a>
            </p>
          </div>

    </div>;
  }
}

SingleDegree.propTypes = {
  data:            React.PropTypes.object.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default SingleDegree;
